import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import './Contact.css'
import emailjs from 'emailjs-com';

import Particle from "../Particle";
import {
    AiFillGithub,
    AiOutlineTwitter,
    AiFillFacebook,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import {
    slideInRight,
    bounceIn,
    slideInLeft,
    slideInUp,
    slideInDown,
} from "react-animations";
import Radium, { StyleRoot } from "radium";



const Contact = () => {
    const styles = {
        slideInLeft: {
            animation: "x 3s",
            animationName: Radium.keyframes(slideInLeft, "bounce"),
        },
        slideInUp: {
            animation: "x 3s",
            animationName: Radium.keyframes(slideInUp, "bounce"),
        },
        slideInRight: {
            animation: "x 3s",
            animationName: Radium.keyframes(slideInRight, "bounce"),
        },
        bounceIn: {
            animation: "x 3s",
            animationName: Radium.keyframes(bounceIn, "bounce"),
        },
        slideInDown: {
            animation: "x 3s",
            animationName: Radium.keyframes(slideInDown, "bounce"),
        },
    };

    const sentEmail = e => {
        e.preventDefault();

        emailjs.sendForm('service_i2iu4b4', 'template_oty9j0n', e.target, 'user_tmhhfCWB1rJGnRM4oK5Oj')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
        window.confirm('Message Sent Successfully')

    }

    return (
        <StyleRoot>
            <Container fluid className="project-section">
                <Particle />
                <Container>
                    <h1 className="project-heading">
                        Contact <strong className="purple">Me </strong>
                    </h1>
                    <Row>
                        <Col md={12} className="home-about-social">

                            {/*       action="https://formspree.io/f/xqknzlnb"
                            method="POST" */}
                            <form onSubmit={sentEmail} >
                                <input
                                    style={styles.slideInLeft}
                                    className="w-75 input"
                                    type="text"
                                    name='name'
                                    placeholder="Your Name"
                                    required
                                />
                                <br />
                                <input
                                    style={styles.slideInRight}

                                    type="email"
                                    className="w-75 input"
                                    name="email"
                                    placeholder="Your Email"
                                    required
                                />
                                <br />
                                <input
                                    style={styles.slideInLeft}

                                    className="w-75 input-message"
                                    type="text"
                                    name='message'
                                    placeholder="Type your message"
                                    required
                                />
                                <br />

                                <button type="submit" style={styles.bounceIn} className="btn submit-btn input">
                                    Send
                                </button>
                            </form>

                            <br /><br /><br />
                            <h5>  <span className="purple">Connect </span>with me</h5>

                            <ul className="home-about-social-links">
                                <li className="social-icons">
                                    <a
                                        href="https://github.com/nhnajmul17"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="icon-colour  home-social-icons"
                                    >
                                        <AiFillGithub />
                                    </a>
                                </li>
                                <li className="social-icons">
                                    <a
                                        href="https://twitter.com/nh_najmul17"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="icon-colour  home-social-icons"
                                    >
                                        <AiOutlineTwitter />
                                    </a>
                                </li>
                                <li className="social-icons">
                                    <a
                                        href="https://www.linkedin.com/in/nhnajmul/"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="icon-colour  home-social-icons"
                                    >
                                        <FaLinkedinIn />
                                    </a>
                                </li>
                                <li className="social-icons">
                                    <a
                                        href="https://www.facebook.com/najmul.hasan.771/"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="icon-colour home-social-icons"
                                    >
                                        <AiFillFacebook />
                                    </a>
                                </li>
                            </ul>
                        </Col>
                    </Row>

                </Container>
            </Container>
        </StyleRoot>
    );
};

export default Contact;